import axios from 'axios';

export default {
  getToken() {
    return localStorage.getItem('user-token');
  },
  async getProposalRefuseReasonsFiltered(params = {}) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/proposal-refuse-reasons`,
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
          params,
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async createProposalRefuseReason(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/proposal-refuse-reasons`,
        {
          name: payload.name,
          susepCode: payload.susepCode,
          isActive: payload.isActive,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateProposalRefuseReason(id, payload) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/proposal-refuse-reasons/${id}`,
        {
          name: payload.name,
          susepCode: payload.susepCode,
          isActive: payload.isActive,
        },
        {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
